import React from 'react';
import Phones from './phones';

// phones.js'in klonu — yalnızca data.secret === true olan telefonları listeler.
// Tüm UI/işlevsellik Phones bileşeninden gelir; `secret` prop'u listeyi ayrıştırır.
const SecretPhones = (props) => <Phones {...props} secret />;

export default SecretPhones;
